module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-6-1f8ead853af240c6a8d82ce47223a7e3.jpg";